const initialState = {
  users: [],
  count: 0
};

export const SET_ACTIVE_USERS = "SET_ACTIVE_USERS";

export function setActiveUsers(activeUsersData) {
  return { type: SET_ACTIVE_USERS, payload: activeUsersData };
}

export default function activeUsersReducer(state = initialState, action) {
  switch (action.type) {
    case SET_ACTIVE_USERS:
      return { 
        ...state, 
        users: action.payload.users || [],
        count: action.payload.count || 0
      };
    default:
      return state;
  }
}
